import Input from '@/components/v1/ui/input/input'
import s from './image-link-input.module.scss'

export type ImageLinkDataType = {
  url: string
  nofollow: boolean
  sponsored: boolean
}

type Props = {
  imageData: ImageLinkDataType
  onChangeLink: (value: string) => void
  onChangeNoFollow: (event: React.ChangeEvent<HTMLInputElement>) => void
  onChangeSponsored: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const ImageLinkInput = ({
  imageData,
  onChangeLink,
  onChangeNoFollow,
  onChangeSponsored,
}: Props) => {
  return (
    <>
      <Input
        name="link"
        type="url"
        label="Image link"
        placeholder="Image link"
        value={imageData?.url}
        onChange={onChangeLink}
      />

      <div className={s.checkboxContainer}>
        <div className={s.checkboxWrapper}>
          <label htmlFor="nofollow">No Follow</label>
          <input
            type="checkbox"
            name="nofollow"
            id="nofollow"
            checked={imageData?.nofollow}
            onChange={onChangeNoFollow}
          />
        </div>

        <div className={s.checkboxWrapper}>
          <label htmlFor="sponsored">Sponsored</label>
          <input
            type="checkbox"
            name="sponsored"
            id="sponsored"
            checked={imageData?.sponsored}
            onChange={onChangeSponsored}
          />
        </div>
      </div>
    </>
  )
}

export default ImageLinkInput
